/** Demo data for the notification centre and the On call settings (?mock=1). */
import type { NotifyMember, NotifyState, RotaView } from '@orgus/protocol';

const MIN = 60_000;
const HOUR = 60 * MIN;

export function demoNotifyState(now: number): NotifyState {
  return {
    vapidPublicKey: null,
    channels: [],
    escalations: [
      {
        key: 'approval:apr_demo_land',
        ref: { type: 'approval', id: 'apr_demo_land' },
        title: 'Approval needed in Qawl-Agents',
        url: '/inbox?approval=apr_demo_land',
        projectId: null,
        rotaId: 'rot_demo',
        step: 1,
        memberId: 'mem_demo_ben',
        startedAt: now - 14 * MIN,
        nextAt: now + 6 * MIN,
        state: 'open',
      },
    ],
    recent: [
      {
        id: 'ntf_demo_9',
        at: now - 4 * MIN,
        urgency: 'high',
        kind: 'escalation',
        title: 'Escalated: Approval needed in Qawl-Agents',
        body: '10 min without an answer from Ana. You are next on Platform on call. Run npm run land.',
        url: '/inbox?approval=apr_demo_land',
        ref: { type: 'approval', id: 'apr_demo_land' },
        actions: [{ id: 'approve', title: 'Approve' }, { id: 'deny', title: 'Deny' }],
      },
      { id: 'ntf_demo_8', at: now - 7 * MIN, urgency: 'critical', kind: 'budget.alert', title: 'Budget limit reached', body: '$80.00 of $80.00 spent (100%). Launched sessions under it stop taking new work.', url: '/spend', ref: { type: 'budget', id: 'bud_demo' } },
      { id: 'ntf_demo_7', at: now - 12 * MIN, urgency: 'high', kind: 'session.unmetered', title: 'Session not metered in billing-service', body: 'No usage has arrived for Refactor the webhook retries since it started 9 min ago.', url: '/sessions', ref: { type: 'session', id: 'ses_demo_unmetered' } },
      { id: 'ntf_demo_6', at: now - 26 * MIN, urgency: 'normal', kind: 'pipeline.failed', title: 'Landing queue failed in billing-service', body: 'fix: retry webhooks with the event id', url: '/pipelines', ref: { type: 'pipelineItem', id: 'itm_demo' } },
      { id: 'ntf_demo_5', at: now - 52 * MIN, urgency: 'high', kind: 'machine.offline', title: 'buildbox went offline', body: 'Its agent stopped reporting. Sessions on it are no longer watched.', url: '/machines', ref: { type: 'machine', id: 'm_demo_build' } },
      { id: 'ntf_demo_4', at: now - 3 * HOUR, urgency: 'low', kind: 'batch', title: '6 updates from Orgus', body: '- Session finished in orgus\n- Session finished in docs-site', url: '/' },
      { id: 'ntf_demo_3', at: now - 26 * HOUR, urgency: 'low', kind: 'digest', title: 'Daily summary', body: '14 sessions ran. 5 landed, 1 failed. $42.10 spent today. 9 approvals answered, median wait 48 s. 3 issues for tomorrow.', url: '/', ref: { type: 'digest', id: 'demo' } },
    ],
  };
}

export const DEMO_MEMBERS: NotifyMember[] = [
  { id: 'mem_demo_ana', name: 'Ana Ruiz', login: 'ana', slackUserId: 'U04ANA1', quietHours: { from: '22:00', to: '07:00' }, minUrgency: 'normal', rules: [{ id: 'rul_1', projectId: null, kind: 'pipeline.failed', action: 'digest' }], dailySummary: true, createdAt: 0 },
  { id: 'mem_demo_ben', name: 'Ben Okafor', login: 'ben', slackUserId: null, quietHours: null, minUrgency: 'high', rules: [], dailySummary: true, createdAt: 0 },
  { id: 'mem_demo_kim', name: 'Kim Sato', login: null, slackUserId: null, quietHours: { from: '23:00', to: '08:00' }, minUrgency: 'normal', rules: [], dailySummary: false, createdAt: 0 },
];

export function demoRotas(now: number): RotaView[] {
  return [
    { id: 'rot_demo', name: 'Platform on call', projectId: null, memberIds: ['mem_demo_ana', 'mem_demo_ben', 'mem_demo_kim'], rotation: 'weekly', anchor: now - 2 * 24 * HOUR, escalateAfterMin: 10, onDutyOnly: true, onDuty: 'mem_demo_ana', nextHandoffAt: now + 5 * 24 * HOUR },
  ];
}
